
// Chart-side helpers for sizing history windows.

// ChartInstrument / groupCoverage were removed on 2026-08-11: grouping the
// coverage table into instruments now happens server-side
// (webapp/services/coverage_cache.py), because doing it in the browser meant
// downloading all 17,566 rows just to populate a search box.

/** Wall-clock-to-trading-time density factor by exchange. "The last N bars"
 *  spans far more wall-clock time on session-bound markets: NSE trades
 *  ~6.25h/day (≈3.8x), forex pauses on weekends (≈1.4x), crypto runs 24/7.
 *  Used to size chart history windows so bar COUNTS come out right. */
export function sessionDensityFactor(exchange: string): number {
  switch (exchange) {
    case "NSE":
    case "BSE":
    case "NFO":
    case "BFO":
    case "MCX":
      return 4;
    case "FX":
      return 1.5;
    default:
      return 1; // DELTA / BINANCE — 24/7
  }
}

/** Milliseconds per bar for a timeframe string. */
export function tfMillis(tf: string): number {
  switch (tf) {
    case "1m":
      return 60_000;
    case "3m":
      return 180_000;
    case "5m":
      return 300_000;
    case "10m":
      return 600_000;
    case "15m":
      return 900_000;
    case "30m":
      return 1_800_000;
    case "1h":
      return 3_600_000;
    case "1d":
      return 86_400_000;
    default:
      return 3_600_000;
  }
}
